import React, {useEffect} from "react";
import DropdownComponent from '../../Components/DropdownComponent';

/*
This component renders all the available info of a dropdown button inside an edit pop up window. It is responsible for all the edit actions 
on dropdown button
*/
const EditDropdownComponent = (props) => {

    const {
        componentId,
        index,
        index2,
        componentsInfo,
        setComponentsInfo,
        rowsComponentsIds,
        setRowsComponentsIds,
        setAdded,
        added,
        clickedEdit,
        editor,
        infoSummary,
        setInfoSummary,
        initComponentsInfo,
        setInitComponentsInfo,
        deleteComps,
        setDeleteComps
    } = props

    const [dropdownButtonText, setDropdownButtonText] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const [clickedDeleteFirst, setClickedDeleteFirst] = React.useState(false);
    const [lockDeleteOption, setLockDeleteOption] = React.useState(false);

    useEffect( () => {

        const tempComponentsInfo = [...componentsInfo];
        const tempInfoSummary = [...infoSummary];


        if(initComponentsInfo === true && componentId !== -1) {
            const domComponents = editor.DomComponents;
            const dropdownComponent = domComponents.componentsById[componentId];
            const dropdownModels = dropdownComponent.attributes.components.models;

            if(dropdownModels.length > 0 && dropdownModels[0].attributes.tagName === 'button'){
                const dropdownButton = dropdownModels[0];
                            
                const labelButton = dropdownButton.get('content');
                const labelButtonInside = dropdownButton.attributes.components.models[0].get('content');
                
                if(labelButton === '' && labelButtonInside === ''){
                    
                    tempInfoSummary[index2].label = 'Dropdown button';
                    tempComponentsInfo[index].info[index2].label = 'Dropdown button'; 
                    setDropdownButtonText("Dropdown button");
                }
                else if(labelButton !== ""){
                    tempInfoSummary[index2].label = labelButton;
                    tempComponentsInfo[index].info[index2].label = labelButton; 
                    setDropdownButtonText(labelButton);
                }
                else {
                    
                    tempInfoSummary[index2].label = labelButtonInside;
                    tempComponentsInfo[index].info[index2].label = labelButtonInside;
                    setDropdownButtonText(labelButtonInside);
                }
                
            }
            if(dropdownModels.length > 1 && dropdownModels[1].attributes.tagName === 'ul'){
                const dropdownUl = dropdownModels[1];
                const dropdownOptions = dropdownUl.attributes.components.models;
            
                const tempOptions = [];
                dropdownOptions.forEach( (option,indexOption) => {
                    
                    let dropdownOption = '';
                    if(option.attributes.components.models[0].attributes.content === ''){

                        dropdownOption = option.attributes.components.models[0].attributes.components.models[0].attributes.content
                        if(dropdownOption === ''){
                            dropdownOption =`Option${indexOption.toString()}`;
                        }
                    }
                    else{
                        dropdownOption = option.attributes.components.models[0].attributes.content;
                    }

                    tempOptions.push(dropdownOption);
                })

                setOptions(tempOptions)
                tempComponentsInfo[index].info[index2].options = tempOptions;
                tempInfoSummary[index2].options = tempOptions;
            }
        }
        setInfoSummary(tempInfoSummary);
        setComponentsInfo(tempComponentsInfo);

    },[clickedEdit,initComponentsInfo])

    
    useEffect( () => {

        setOptions(componentsInfo[index].info[index2].options);
        setDropdownButtonText(componentsInfo[index].info[index2].label);

    },[added])
    

    useEffect( () => {
        if(clickedDeleteFirst === true){

            const tempComponentsInfo = [...componentsInfo];
            const lengthOptions = tempComponentsInfo[index].info[index2].options.length;

            if(lengthOptions === 1){
                setLockDeleteOption(true);
            }
            setClickedDeleteFirst(false);
        }
        if(lockDeleteOption === true){
            setTimeout(() => {
                setLockDeleteOption(false)  
            }, 2000);
        }

    },[clickedDeleteFirst])

    const handleTextButton = (val) => {
        const tempInfoSummary = [...infoSummary];
        tempInfoSummary[index2].label = val.target.value;
        setInfoSummary(tempInfoSummary);

        setDropdownButtonText(val.target.value);

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info[index2].label = val.target.value;
        setComponentsInfo(tempComponentsInfo);

    }

    const handleOptionLabel = (val, index3) => {

        const tempInfoSummary = [...infoSummary];
        tempInfoSummary[index2].options[index3] = val.target.value;
        setInfoSummary(tempInfoSummary);

        const tempOptions = [...options];
        tempOptions[index3] = val.target.value;
        setOptions(tempOptions);

        const tempComponentsInfo =[...componentsInfo];
        tempComponentsInfo[index].info[index2].options[index3] = val.target.value;
        setComponentsInfo(tempComponentsInfo);

        setAdded(true)
    }

    const deleteElement = () => {
         
        const tempDeleteComps = [...deleteComps];
        tempDeleteComps.push(rowsComponentsIds[index].insideIds[index2]);
        setDeleteComps(tempDeleteComps)

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].div.splice(index2,1);
        tempComponentsInfo[index].info.splice(index2,1);
        setComponentsInfo(tempComponentsInfo);
        
        const tempRowsComponentsIds = [...rowsComponentsIds];
        tempRowsComponentsIds[index].insideIds.splice(index2,1);
        setRowsComponentsIds(tempRowsComponentsIds);

        setInitComponentsInfo(false);
        setAdded(true);
    }

    const addOption= () => {
        
        const tempComponentsInfo = [...componentsInfo];
        const lengthOptions = tempComponentsInfo[index].info[index2].options.length;
        tempComponentsInfo[index].info[index2].options.push(`Link${(lengthOptions+1).toString()}`);
        setComponentsInfo(tempComponentsInfo);
        setAdded(true);

    }

    const deleteOption = (index3) => {
        
        const optionsLength = componentsInfo[index].info[index2].options.length;
        if(index3 === 0 && optionsLength === 1){
            setClickedDeleteFirst(true)
        }
        if(optionsLength >1){
            const tempComponentsInfo = [...componentsInfo];
            tempComponentsInfo[index].info[index2].options.splice(index3,1);
            setComponentsInfo(tempComponentsInfo);
        } 
        setAdded(true);
    }

    return(
        <DropdownComponent
            deleteElement = {deleteElement}
            handleTextButton = {handleTextButton}
            dropdownButtonText = {dropdownButtonText}
            options = {options}
            handleOptionLabel = {handleOptionLabel}
            lockDeleteOption = {lockDeleteOption}
            deleteOption = {deleteOption}
            addOption = {addOption}
        />
    )
}

export default EditDropdownComponent;